import { fetchMarketResearchById } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const MarketResearchByIdKeys = {
    all: ['marketresearchbyid'] as const,
    lists: () => [...MarketResearchByIdKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...MarketResearchByIdKeys.lists(), page, perPage, filters] as const,
    details: () => [...MarketResearchByIdKeys.all, 'detail'] as const,
    detail: (params: number) => [...MarketResearchByIdKeys.details(), params] as const,
}

export const useMarketResearchByIdQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchMarketResearchById(SK_PESQUISA),
        queryKey: MarketResearchByIdKeys.detail(SK_PESQUISA),
    })
}
